<template>
  <v-select
    v-model="internalValue"
    :clearable="!required"
    :multiple="multiple"
    :searchable="false"
    label="name"
    :options="carriers"
    :placeholder="placeholder || $t('orders.carrier')"
    :class="['select-carrier', customClass]"
    append-to-body
  >
    <template slot="no-options"> {{ $t("noRecord") }} </template>

    <template slot="option" slot-scope="option">
      <div :class="`option-chip carrier-${option.id}`">
        <CarrierLogo :item="option" />
        <span class="select-label">{{ option.name }}</span>
      </div>
    </template>
    <template slot="selected-option" slot-scope="option">
      <div :class="`option-chip carrier-${option.id} selected`">
        <CarrierLogo :item="option" />
      </div>
    </template>
    <template #open-indicator="{}">
      <i class="md-icon md-icon-font md-icon-image md-theme-default">
        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 10l5 5 5-5z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </i>
    </template>
  </v-select>
</template>

<script>
import CarrierLogo from "./CarrierLogo.vue";

export default {
  components: {
    CarrierLogo,
  },
  props: {
    value: {
      type: [String, Array, Object, Number, null],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    default: {
      type: Boolean,
      default: false,
    },
    allowedCarriers: {
      type: Array,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      localValue: null, // Fallback value
    };
  },
  computed: {
    internalValue: {
      get() {
        let parsedValue = [];
        if (!this.value) {
          return this.localValue;
        }
        if (Array.isArray(this.value)) {
          parsedValue = [...this.value];
        } else if (typeof this.value === "string") {
          parsedValue = this.value.split(",");
        }
        const res = parsedValue?.map((val) => this.carriers.find((carrier) => carrier.name === val)) ?? null;

        return res;
      },
      set(newValue) {
        if (!newValue) {
          this.localValue = newValue;
          this.$emit("input", null);
          return;
        }
        this.localValue = newValue;
        if (this.multiple === true) {
          if (newValue.length === 0) {
            this.$emit("input", null);
            return;
          } else {
            this.$emit(
              "input",
              newValue?.map((item) => item.name)
            );
          }
        } else {
          this.$emit("input", newValue.name);
        }
      },
    },
    carriers() {
      const carrierItems = structuredClone(this.$store.state.shippingData.carriers) || [];
      const logoByName = {
        DHL: "/img/logo-dhl.png",
        DPD: "/img/logo-dpd.png",
        Spedition: "/img/logo-speedition.png",
        MULTI: "/img/logo-multi.png",
      };
      carrierItems.forEach((carrier) => {
        switch (carrier.id) {
          case -1:
            carrier.name = this.$t("orders.speditionWithoutNumbers");
            carrier.logo = "/img/logo-speedition-without-number.png";
            break;
          default:
            if (!carrier.logo && logoByName[carrier.name]) {
              carrier.logo = logoByName[carrier.name];
            }
            break;
        }
      });
      if (this.default) {
        carrierItems.splice(
          carrierItems.findIndex((carrier) => carrier.id === -1),
          1
        );
      }
      if (this.allowedCarriers && this.allowedCarriers.length) {
        return carrierItems.filter((c) => this.allowedCarriers.includes(c.name));
      }
      return carrierItems;
    },
  },
  created() {
    if (!this.$store.state.shippingData.carriers || this.$store.state.shippingData.carriers.length === 0) {
      this.$store.dispatch("shippingData/getCarriers");
    }
  },
};
</script>

<style lang="scss">
.vs--open {
  .md-icon {
    transition: all 0.3s ease;
    transform: rotate(180deg);
  }
}
.vs__dropdown-option--selected {
  .option-chip {
    &:before {
      position: absolute;
      content: " ";
      width: 48px;
      height: 48px;
      top: 50%;
      left: 50%;
      z-index: 11;
      border-radius: 50%;
      transform: translate(-50%, -50%);
    }
    &:after {
      position: absolute;
      content: " ";
      width: 6px;
      height: 13px;
      top: 0;
      /* left: 5px; */
      /* z-index: 12; */
      border: 2px solid #ffffff;
      border-top: 0;
      border-left: 0;
      opacity: 0;
      -webkit-transform: rotate(45deg) scale3D(0.15, 0.15, 1);
      transform: rotate(45deg) scale3D(0.15, 0.15, 1);
      opacity: 1;
      -webkit-transform: rotate(45deg) scaleX(1);
      transform: rotate(45deg) scaleX(1);
      -webkit-transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      /* border-color: #9c27b0 !important; */
      top: 25%;
      right: 10px;
    }
  }
}
.option-chip {
  padding: 0 0px;
  border-radius: 32px;
  display: flex;
  gap: 3px;
  position: relative;
  &.selected {
    padding: 0 0px !important;
  }
  .select-label {
    padding-right: 30px;
    font-size: 13px;
  }
  .logo {
    max-width: 50px;
    max-height: 30px;
    border-radius: 15px;
    background-color: #e0e0e0;
    overflow: hidden;
  }
  //   &.carrier-1 {
  //     background-color: #ffcd00;
  //     .logo {
  //       background-color: #ffcd00;
  //     }
  //     // color: #fff;
  //   }
}
.select-carrier {
  .vs__selected {
    padding-left: 0 !important;
  }
  .vs__dropdown-menu {
    min-width: 300px;
    .logo {
      border-radius: 15px;
      overflow: hidden;
    }
  }
}
</style>
